import React from "react";
/* eslint-disable */
import Header from "../../header";
import Banner from ".././Banner";
import SubNav from ".././SubNav";
import Footer from "../../Footer"
import CustomTable from "../../CustomTable.js";
import pricing from '../../../assets/Data/pricingData'

const reliablesecurestorage = require("../../../assets/icons-pack/4.1 Elastic Volume Services/ic_01_reliablesecurestorage.svg");
const optimizezone = require("../../../assets/icons-pack/4.1 Elastic Volume Services/ic_02_optimizezone.svg");
const quicklyscaleup = require("../../../assets/icons-pack/4.1 Elastic Volume Services/ic_03_quicklyscaleup.svg");
const availiblity = require("../../../assets/icons-pack/4.1 Elastic Volume Services/ic_04_availiblity.svg");

// import '../styles.css';
const EVS = () => {
    const heading = `ELASTIC VOLUME SERVICE (EVS)`;
    const details = `High-Performance Solid-State Drive (SSD) block storage designed for intensive workloads.`;

    const overview = [
        `Elastic Volume Service (EVS) is a high-performance Solid-State Drive (SSD) based Storage designed to support I/O intensive workloads with significantly high throughput and low latency. DETASAD EVS provides highly-available, fault-tolerant & redundant options that are becoming much more popular given their relatively economical cost & ability to avoid the capital expenditure associated with acquiring, building & maintaining the infrastructure internally.`
    ];

    const advantages = [
        [
            `Reliable, Secure Storage`,
            `Each EVS volume provides redundancies within its Availability Zone to protect against failures. Encryption and access control policies deliver a strong defense-in-depth security strategy for your data.`,
            reliablesecurestorage
        ],
        [
            `Optimized Performance`,
            `An EVS–optimized instance provides dedicated network capacity for EVS volumes. This provides the best performance for your EVS volumes by minimizing network contention between EVS and your instance.`,
            optimizezone
        ],
        [
            `Quickly Scale Up, Easily Scale Down`,
            `EVS allows you to optimize your volumes for capacity, performance, or cost giving you the ability to dynamically adapt to the changing needs of your business.`,
            quicklyscaleup
        ],
        [
            `Availability`,
            `Each EVS is designed for 99.99% availability and automatically replicates to protect your applications from component failure.`,
            availiblity
        ]
    ];

    const functions = [
        [
            `Data Availability `,
            [
                `When you create any EVS volume, it is automatically replicated within that zone to prevent data loss due to failure of any single hardware component. After you create a volume, you can attach it to any block storage instance in the same zone. After you attach a volume, it appears as a native block device similar to a hard drive or other physical device. At that point, the instance can interact with the volume just as it would with a local drive.`
            ]
        ],
        [
            `Data Persistence `,
            [
                `EVS are off-instance storage that can persist independently from the life of an instance. You continue to pay for the volume usage as long as the data persists. By default, Block Storage volumes that are attached to a running instance automatically detach from the instance with their data intact when that instance is terminated. The data persists on the volume until the volume is deleted explicitly. The physical block storage used by EVS volumes is overwritten with zeroes before it is allocated to another account.`
            ]
        ],
        [
            `Backup Service `,
            [
                `EVS Storage provides the ability to create snapshots (backups) of any volume and write a copy of the data in the volume to DETASAD Object Storage, where it is stored.`,
                `These snapshots can be used to create multiple new volumes or move volumes across. When you create a new volume from a snapshot, it's an exact copy of the original volume at the time the snapshot was taken.`
            ]
        ]
    ];
    let TablesData = []
    pricing.map(price => {
        price.price = parseFloat(price.price).toFixed(2);
        if(price.name.includes('Elastic-Volume-Service') ){
            console.log(price,'price')
            price['hourlyPricing'] = (price.price / 720).toFixed(2)
            price['monthlyPricing'] = price.price
            TablesData.push(price) 
        }
    })
    return (
        <div>
            <Header />
            <Banner heading={heading} details={details} className="bg-storage"/>
            <SubNav overview={overview} advantages={advantages} functions={functions} CustomTable={CustomTable} TablesData = {TablesData} onlyMonthly/>
            <Footer />
        </div>
    );
};

export default EVS;
